<template>
  <Integration-form
    mode="create"
    @submit="handleSubmit"
  />
</template>

<script>
  import { IntegrationForm } from '../../components'
  import { useCreateIntegration } from './integrationHooks'

  export default {
    name: 'AddIntegration',
    components: { IntegrationForm },
    mixins: [
      useCreateIntegration('handleSubmit'),
    ],
  }
</script>

<style scoped>

</style>
